export const sanitizeNumber = (val = '') => String(val).replace(/\D/g, '');

export const formatNumberToPTBRCurrency = (amount: number) => {
  if (Number.isNaN(Number(amount))) {
    return '--';
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount);
};

export const formatNumberToPTBRStyle = ({
  amount,
  decimalPlaces = 2,
}: {
  amount: number;
  decimalPlaces?: number;
}) =>
  Number(amount).toLocaleString('pt-br', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

export const formatToPercentage = (
  value: number | string,
  decimalPlaces = 2,
  roundToMinimum = false
): string => {
  if (Number.isNaN(Number(value))) {
    return '--';
  }

  const numericValue = Number(value);
  let formattedValue = numericValue;

  if (roundToMinimum && numericValue !== 0) {
    const rounded = Number(numericValue.toFixed(decimalPlaces));
    if (rounded === 0) {
      const minValue = 1 / Math.pow(10, decimalPlaces);
      formattedValue = numericValue >= 0 ? minValue : -minValue;
    }
  }

  return `${formattedValue.toFixed(decimalPlaces).replace('.', ',')}%`;
};

export const formatToMonetary = ({
  value,
  currency = 'BRL',
  locale = 'pt-br',
  notation = 'standard',
  ...rest
}: NumberToMonetaryParams): string =>
  new Intl.NumberFormat(locale, {
    currency,
    notation,
    style: 'currency',
    ...rest,
  }).format(Number(value));

type NumberToMonetaryParams = {
  value: number | string;
  currency?: string;
  locale?: 'pt-br' | 'en-us' | 'fr-fr' | 'ko-kr';
  notation?: 'standard' | 'compact';
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const parseToNumber = (value: string, decimals: number = 2): number => {
  const normalizedValue = Number(value.replace(/\D/g, '')) / 100;
  return parseFloat(normalizedValue.toFixed(decimals));
};

export const normalizeString = (word: string) =>
  word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
